var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerTwin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 315,
    viewBox: "0 0 353 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0992 22.2181C-6.40419 50.7074 -6.40416 96.8977 22.0992 125.387L211.603 314.797H286.551L352.297 249.083L125.319 22.2181C96.8158 -6.27125 50.6026 -6.27125 22.0992 22.2181Z",
    fill: "url(#paint0_linear_1155_12)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.286 33.22C129.783 61.7093 129.783 107.9 158.286 136.389L336.986 315L352.101 299.893V123.77L261.506 33.22C233.003 4.7307 186.79 4.7307 158.286 33.22Z",
    fill: "url(#paint1_linear_1155_12)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1155_12",
    x1: 70.3777,
    y1: 70.4723,
    x2: 260.866,
    y2: 261.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1155_12",
    x1: 158.286,
    y1: 33.22,
    x2: 348.775,
    y2: 223.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerTwin);
export default __webpack_public_path__ + "static/media/banner-twin.cb47ba41e65b071a11adad7675b59099.svg";
export { ForwardRef as ReactComponent };